var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmarkDome = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 22.4884C1.5 22.0677 1.83855 21.7268 2.25618 21.7268H21.7438C22.1614 21.7268 22.5 22.0677 22.5 22.4884C22.5 22.909 22.1614 23.25 21.7438 23.25H2.25618C1.83856 23.25 1.5 22.909 1.5 22.4884Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 19.4419C3 19.0213 3.33855 18.6803 3.75618 18.6803H20.2438C20.6614 18.6803 21 19.0213 21 19.4419C21 19.8625 20.6614 20.2035 20.2438 20.2035H3.75618C3.33855 20.2035 3 19.8625 3 19.4419Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 11.1637H6V15.696H4.5V11.1637Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 11.25H10.5V15.696H9V11.25Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 11.1637H15V15.696H13.5V11.1637Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11.1637H19.5V15.696H18V11.1637Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 15.696H19.5V16.4514C19.5 16.8686 19.1642 17.2068 18.75 17.2068H5.25C4.83579 17.2068 4.5 16.8686 4.5 16.4514V15.696Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M3 10.5C3 10.0858 3.33579 9.75 3.75 9.75H20.25C20.6642 9.75 21 10.0858 21 10.5V10.5C21 10.9142 20.6642 11.25 20.25 11.25H10.5H3.75C3.33579 11.25 3 10.9142 3 10.5V10.5Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 9.75C19.5 7.95979 18.7098 6.2429 17.3033 4.97703C15.8968 3.71116 13.9891 3 12 3C10.0109 3 8.10322 3.71116 6.6967 4.97703C5.29018 6.2429 4.5 7.95979 4.5 9.75H6.00829C6.00829 8.31981 6.63955 6.94819 7.76322 5.9369C8.88688 4.9256 10.4109 4.35746 12 4.35746C13.5891 4.35746 15.1131 4.9256 16.2368 5.9369C17.3604 6.94819 17.9917 8.31981 17.9917 9.75H19.5Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 2.25C11.25 1.83579 11.5858 1.5 12 1.5C12.4142 1.5 12.75 1.83579 12.75 2.25V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3V2.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmarkDome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landmark-dome.02e8c22e4c978835784ab621f7e671a9.svg";